import client from "@/services/sentry";
import * as Sentry from "@sentry/browser";

export default {
  install(Vue) {
    Vue.sentry = client;
    window.Sentry = Sentry;
    Vue.prototype.$sentry = client;
  }
};
